module.exports = __webpack_public_path__ + "static/img/4-10.87710ce6.png";